import React from 'react';

import {useFeatures} from '@udemy/react-experimentation-provider';

import {LOHP_HERO_BANNER_CONSOLIDATED} from 'src/lib/experimentation-helper';

import {
    ConsolidatedHeroBanner,
    ConsolidatedHeroBannerDetailSkeleton,
    ConsolidatedHeroBannerSkeleton,
} from '../consolidated-hero-banner';
import {MarketingHeroBannerProps} from '../marketing-hero-banner.react-component';

/** Gates the consolidated banner variant behind LOHP_HERO_BANNER_CONSOLIDATED. */
export const WithConsolidatedHeroBanner = (
    WrappedComponent: React.ComponentType<MarketingHeroBannerProps>,
) => {
    const WithConsolidatedWrapper = (defaultProps: MarketingHeroBannerProps) => {
        const {isLoading: isFeaturesLoading, featureVariantAssignments: features} = useFeatures([
            LOHP_HERO_BANNER_CONSOLIDATED,
        ]);
        const isConsolidatedEnabled = Boolean(
            features.get(LOHP_HERO_BANNER_CONSOLIDATED)?.configuration
                ?.shouldShowConsolidatedHeroBanner,
        );

        if (isFeaturesLoading) {
            return <ConsolidatedHeroBannerSkeleton className={defaultProps.className} />;
        }

        if (!isConsolidatedEnabled) {
            return <WrappedComponent {...defaultProps} />;
        }

        if (defaultProps.isLoading) {
            return <ConsolidatedHeroBannerDetailSkeleton className={defaultProps.className} />;
        }

        if (!defaultProps.heroBanners?.length) {
            return <WrappedComponent {...defaultProps} />;
        }
        return <ConsolidatedHeroBanner {...defaultProps} />;
    };

    return WithConsolidatedWrapper;
};
